import type { PropsWithChildren } from "react"
import React from "react"
import { navigate } from "gatsby"
import {
    Provider,
    useCoreThemeForProvider,
} from "@mallardbay/lib-react-components"

export default function ThemeProvider({
    children,
}: Readonly<PropsWithChildren>) {
    const themeForProvider = useCoreThemeForProvider()

    return (
        <Provider
            theme={themeForProvider}
            uploadcarePubkey={process.env.GATSBY_UPLOAD_CARE_PK ?? ""}
            navigate={navigate}
        >
            {children}
        </Provider>
    )
}
